/**
 * /403 — Forbidden.
 *
 * Reached when a user has a valid session but the wrong role for the
 * requested route (via RequireRole). A 403 refusing the *session* rather than
 * the route goes to `AccountInactive` instead, which is terminal — this screen
 * is for a route the user simply may not have.
 */

import {
  Badge,
  Box,
  Button,
  Center,
  Group,
  Paper,
  Stack,
  Text,
  ThemeIcon,
  Title,
} from "@mantine/core";
import { IconHome, IconLock } from "@tabler/icons-react";
import { useNavigate } from "react-router-dom";
import { useUser } from "../auth";

export function ForbiddenPage() {
  const user = useUser();
  const navigate = useNavigate();

  return (
    <Center mih="60vh" px="md">
      <Paper p="xl" radius="lg" withBorder shadow="sm" maw={520} w="100%">
        <Stack gap="md" align="center" ta="center">
          <ThemeIcon variant="light" color="red" radius="xl" size={72}>
            <IconLock size={36} />
          </ThemeIcon>
          <Stack gap={4} align="center">
            <Title order={2}>Access denied</Title>
            <Text c="dimmed" size="sm" maw={400}>
              Your role doesn't have permission to view this page. If you believe this is a mistake,
              contact your compliance admin.
            </Text>
          </Stack>

          {user ? (
            <Group gap="xs">
              <Text size="xs" c="dimmed">
                Signed in as
              </Text>
              <Text size="xs" fw={500}>
                {user.email}
              </Text>
              <Badge variant="light" size="xs">
                {user.role}
              </Badge>
            </Group>
          ) : null}

          <Box mt="sm">
            <Button
              leftSection={<IconHome size={16} />}
              variant="light"
              onClick={() => navigate("/batches", { replace: true })}
            >
              Back to batches
            </Button>
          </Box>
        </Stack>
      </Paper>
    </Center>
  );
}
